import React from "react";
import Dashboard from "./Dashboard";
import InitiateOnboarding from "./InitiateOnboarding";
import ReadyForOnboarding from "./ReadyForOnboarding";
import { NewTab, PageHeader, PageTabAdv, PageTitle } from "../../../components";

const EOnboarding = () => {
  const EOnboardingMenus = [
    {
      title: "Dashboard",
      page: <Dashboard />,
      type: "main",
    },

    {
      title: "Initiate Onboarding",
      page: <InitiateOnboarding />,
      type: "main",
    },
    // {
    //   title: "Ready For Onboarding",
    //   page: <ReadyForOnboarding />,
    //   type: "main",
    // },
    {
      title: "Documents",
      // icon: "settings",
      type: "sub",
      link: "/e-onboarding/documents",
    },
    {
      title: "CheckList",
      // icon: "settings",
      type: "sub",
      link: "/e-onboarding/checklist",
    },
  ];
  return (
    <>
      <PageHeader
        Section={
          <div className="flex my-3">
            <PageTitle title={"E-Onboarding"} tag="h5" />
          </div>
        }
      />
      <NewTab
        tabs={EOnboardingMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="e-onboarding"
      />
    </>
  );
};

export default EOnboarding;
